import type { z } from "zod";

import { IconArrowRight24Line } from "@/components/icons/iconoir";
import { SelectIcon } from "@/components/icons/select-icon";
import { RichText } from "@/components/rich-text";
import { cn } from "@/lib/utils";
import type { customCardSchema } from "@/schemas";

import { Link } from "../ui/link";

export function LinkNoMedia({
  className,
  ...props
}: z.infer<typeof customCardSchema> & { className?: string }) {
  const { title, richTextTitle, url, icon, external } = props;

  return (
    <Link
      href={url ?? "/"}
      external={!!external}
      target={external ? "_blank" : undefined}
      data-ph-capture-attribute-cta_label={`Custom Card (LinkNoMedia) - ${title}`}
      data-ph-capture-attribute-cta_url={url}
    >
      <article
        className={cn(
          "group rounded-container border-grey-100 mx-auto flex w-full max-w-[530px] flex-col overflow-hidden border",
          className
        )}
      >
        <div className="flex h-[176px] flex-col justify-between p-4 lg:h-[224px] lg:p-6">
          {icon && <SelectIcon id={icon} className="size-14" alt={icon} />}
          <div className="flex flex-col gap-2 lg:gap-4">
            {richTextTitle ? (
              <h3 className="text-heading-16 lg:text-heading-20">
                <RichText value={richTextTitle} />
              </h3>
            ) : (
              <h3 className="text-heading-16 lg:text-heading-20">{title}</h3>
            )}
            <div className="flex transition-transform duration-200 group-hover:translate-x-2.5">
              <IconArrowRight24Line />
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
}
